import { Button, HStack, Stack } from '@chakra-ui/react';
import { MdAdd } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import { Header } from '@/components/ui/Header/Header';
import { Breadcrumbs } from '@/components/ui/Navigation/Breadcrumbs';
import { createRolesHook } from '@/hooks/useRoles';
import { Breadcrumb } from '@/types/Breadcrumbs';

import { useGetSurveysQuery } from '../api';
import { SurveyList } from '../components';

const breadcrumbs: Breadcrumb[] = [
  {
    path: '/app/surveys',
    displayValue: 'Ankiety',
    isCurrentRoute: true,
  },
];

const useRoles = createRolesHook(['user', 'admin']);

export const SurveysPage = () => {
  useRoles();
  const { data: surveys, isLoading } = useGetSurveysQuery();
  const navigate = useNavigate();

  return (
    <Stack spacing={6}>
      <Breadcrumbs breadcrumbs={breadcrumbs} />

      <HStack justify="space-between" align="center">
        <Header pb={0}>Ankiety</Header>
        <Button
          colorScheme="purple"
          leftIcon={<MdAdd />}
          onClick={() => navigate('/app/surveys/new')}
        >
          Nowa ankieta
        </Button>
      </HStack>

      <SurveyList surveys={surveys} isLoading={isLoading} />
    </Stack>
  );
};
